import { createContext } from 'react';

export const SuperSearchDropdownContext = createContext({});
export const reducer = (state, action) => {
  switch (action.type) {
    case 'TOGGLE_DROPDOWN': {
      return { ...state, showDropDown: action.payload };
    }
    case 'TOGGLE_LOADER': {
      return { ...state, loading: action.payload };
    }
    case 'SET_DATA': {
      return { ...state, data: action.payload };
    }
    case 'SET_INPUTVALUE': {
      return { ...state, inputValue: action.payload };
    }
    case 'SET_SELECTED_ROW_NUMBER': {
      return { ...state, selectedRowNumber: action.payload };
    }
    case 'SET_SEARCH_STATUS': {
      return { ...state, searchStatus: action.payload };
    }

    default: {
      throw new Error('Unhandled action type in SuperSearchDropdownContext reducer');
    }
  }
};

SuperSearchDropdownContext.displayName = 'SuperSearchDropdownContext';
